<script lang="ts" setup>
import { ICountry } from '@bc-library/interface';
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  country: string | ICountry
  tooltip?: string
  width?: string
}>(), {
  width: 'w-5',
})

const lowerCaseCountry = computed(() => {
  const thisCountry = (typeof props.country === 'string') ? props.country : props.country?._id
  if (thisCountry === 'UK' || thisCountry === 'uk')
    return 'gb'
  return thisCountry?.toLowerCase()
})
</script>

<template>
  <picture class="h-auto flex shrink-0" :class="[{ 'cursor-help': tooltip }, width]" :title="tooltip" :alt="`Flag ${lowerCaseCountry}`">
    <source
      type="image/webp"
      :srcset="`https://flagcdn.com/40x30/${lowerCaseCountry}.webp ,https://flagcdn.com/80x60/${lowerCaseCountry}.webp 2x,https://flagcdn.com/120x90/${lowerCaseCountry}.webp 3x`"
    >
    <source
      type="image/png"
      :srcset="`https://flagcdn.com/40x30/${lowerCaseCountry}.png ,https://flagcdn.com/80x60/${lowerCaseCountry}.png 2x,  https://flagcdn.com/120x90/${lowerCaseCountry}.png 3x`"
    >
    <img
      :src="`https://flagcdn.com/40x30/${lowerCaseCountry}.png`"
      width="40"
      height="30"
      :alt="lowerCaseCountry"
    >
  </picture>
</template>
